module.exports = __webpack_public_path__ + "/images/shop/payment-form/cc-help.png";